import {useEffect, useState} from "react";
import * as React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "react-query";

import {ACard} from "@atiautomacao/ati-ui-library";
import {
    Container,
    TextField,
    InputLabel,
    FormHelperText, Select, MenuItem,
    FormControlLabel, 
    Switch,
} from "@mui/material";
import Box from "@mui/material/Box";

import {
    FindAllPowerStationReactQuery,
    FindBrokerByIdReactQuery,
    SaveBrokerReactQuery
} from "./BrokerReactQuery";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {HeaderMenu} from "../HeaderMenu";
import {PowerStationProps} from "../../../Shared/Types/PowerStation";
import {MenuProps} from "../../../Utils/PropsStyles";
import {BrokerProps} from "../../../Shared/Types/Broker";
import {useSnackbar} from "notistack";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Typography from "@mui/material/Typography";

export const BrokerFormPage = () => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const id = location.state?.id as string;
    const navigate = useNavigate();

    const mutationSave = SaveBrokerReactQuery();
    const mutationFindById = FindBrokerByIdReactQuery();
    const mutationFindAllPowerStation = FindAllPowerStationReactQuery();

    const [brokerName, setBrokerName] = useState<string>("");
    const [ipAddress, setIpAddress] = useState<string>("");
    const [port, setPort] = useState<number>(NaN);
    const [txQueue, setTxQueue] = useState<string>("");
    const [rxQueue, setRxQueue] = useState<string>("");
    const [notificationQueue, setNotificationQueue] = useState<string>("");
    const [powerStation, setPowerStation] = useState<number>(-1);
    const [powerStationList, setPowerStationList] = useState<PowerStationProps[]>([]);
    const [gwid, setGwid] = useState<number>(NaN);
    const [enabled, setEnabled] = useState<boolean>(true);

    useEffect(() => {
        if(id){
            mutationFindById.mutate(Number(id), {
                onSuccess: (data) => {
                    let broker = data?.data as BrokerProps;
                    setBrokerName(broker.name);
                    setIpAddress(broker.ipAddress);
                    setPort(broker.port);
                    setTxQueue(broker.txQueue);
                    setRxQueue(broker.rxQueue);
                    setNotificationQueue(broker.notificationQueue)
                    setPowerStation(broker.powerStation.id);
                    setGwid(broker.gwid);
                    setEnabled(broker.enabled);
                }
            });
        }
    }, []);

    useEffect(() => {
        setPowerStationList(mutationFindAllPowerStation.data ?? [])
    }, [mutationFindAllPowerStation.data]);

    const validateBrokerData = (data:BrokerProps) => {
        const requiredFields:Array<keyof BrokerProps> = [
            'name',
            'ipAddress',
            'port',
            'txQueue',
            'rxQueue',
            'notificationQueue',
            'powerStation',
            'gwid'
            // ,'enabled'
        ];

        for (const field of requiredFields) {
            if (data[field] === null || data[field] === undefined || data[field] === '') {
                enqueueSnackbar(`Preencha os campos obrigatórios!`, { variant: "error" });
                return false
            }
        }
        return true
    }

    const handleSave = () => {
        const newPoweStation = powerStationList.find((entity) => entity.id == powerStation);
        if(newPoweStation != null && port != null){
            let newBroker: BrokerProps = {
                id: id != null ? Number(id) : null,
                name: brokerName,
                ipAddress: ipAddress,
                port: port,
                txQueue: txQueue,
                rxQueue: rxQueue,
                notificationQueue: notificationQueue,
                powerStation: newPoweStation,
                isSelected: false,
                gwid: gwid,
                enabled: enabled
            }
            if(validateBrokerData(newBroker)){
                mutationSave.mutate(newBroker, {
                    onSuccess: () => {
                        navigate(SystemRoutes.SETTINGS_BROKER);
                    }
                });
            }
        }else{
            enqueueSnackbar(`Preencha os campos obrigatórios!`, { variant: "error" });
        }

    }

    async function handleGwid() {
        try {
            const response = await axios.get('/api/configuration/liveconfig');
            if(response?.data.data){
                const gwidAddressUrl = response.data.data.value;
                try {
                    const responseOfExternApi = await fetch(`https://${gwidAddressUrl}/api/next-gwid`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-identity': '498f%3o9fj@s$fgj',
                        },
                    });
                    const gwidResponse = await responseOfExternApi?.json();
                    const number = gwidResponse?.data;
                    setGwid(number)
                } catch (error){
                    setGwid(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
                    console.log("Erro ao buscar o endereço GWID usando a URL externa", error);
                }
            } else {
                setGwid(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
            }
        } catch (error){
            setGwid(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
            console.log("Erro ao buscar o endereço GWID", error);
        }

    }

    return (
        <>
            <HeaderMenu isOnSave={true} handleSave={handleSave} systemRoutes={SystemRoutes.SETTINGS_BROKER}/>
            <Box>
                <ACard>
                    <Container style={{
                        marginLeft: -10,
                        display: 'flex',
                        flexDirection: window.innerWidth <= 900 ? "column": "row",
                        alignItems: 'left',
                        justifyContent: 'left',
                        columnGap: 30
                    }}>
                        <div style={{width: '100%'}}>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="type-name">Nome</InputLabel>
                                <TextField
                                    error={brokerName === ""}
                                    fullWidth
                                    id="type-name"
                                    variant="standard"
                                    placeholder={"Nome do broker"}
                                    onChange={(value) => setBrokerName(value.target.value)}
                                    value={brokerName}
                                />
                                {
                                    brokerName === "" &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="ipAddress">Endereço IP</InputLabel>
                                <TextField
                                    fullWidth
                                    error={ipAddress === ""}
                                    id="ipAddress"
                                    variant="standard"
                                    placeholder={"Endereço IP"}
                                    onChange={(value) => setIpAddress(value.target.value)}
                                    value={ipAddress}
                                />
                                {
                                    ipAddress === "" &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="port">Porta</InputLabel>
                                <TextField
                                    fullWidth
                                    error={isNaN(port)}
                                    id="port"
                                    variant="standard"
                                    placeholder={"Digite a porta"}
                                    type="number"
                                    onChange={(value) => setPort(parseInt(value.target.value))}
                                    value={port}
                                />
                                {
                                    isNaN(port) &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="txQueue">Fila TX</InputLabel>
                                <TextField
                                    fullWidth
                                    error={txQueue === ""}
                                    id="txQueue"
                                    variant="standard"
                                    placeholder={"Digite a fila TX"}
                                    onChange={(value) => setTxQueue(value.target.value)}
                                    value={txQueue}
                                />
                                {
                                    txQueue === '' &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="rxQueue">Fila RX</InputLabel>
                                <TextField
                                    fullWidth
                                    error={rxQueue === ""}
                                    id="rxQueue"
                                    variant="standard"
                                    placeholder={"Digite a fila RX"}
                                    onChange={(value) => setRxQueue(value.target.value)}
                                    value={rxQueue}
                                />
                                {
                                    rxQueue === '' &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="notificationQueue">Fila de notificação</InputLabel>
                                <TextField
                                    fullWidth
                                    error={notificationQueue === ""}
                                    id="notificationQueue"
                                    variant="standard"
                                    placeholder={"Digite a fila de notificação"}
                                    onChange={(value) => setNotificationQueue(value.target.value)}
                                    value={notificationQueue}
                                />
                                {
                                    notificationQueue === '' &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                        </div>
                        <div style={{width: '100%'}}>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="selectPowerStation">Usina</InputLabel>
                                <Select
                                    fullWidth
                                    labelId="selectPowerStation"
                                    id="selectPowerStation"
                                    placeholder={"Selecione a usina"}
                                    value={powerStation}
                                    label="Tipo"
                                    onChange={(value) => setPowerStation(value.target.value as number)}
                                    variant={"standard"}
                                    MenuProps={MenuProps}
                                >
                                    {
                                        powerStationList.map((entity,index) => {
                                            return (
                                                <MenuItem key={index.valueOf()} value={entity.id}>{entity.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                { powerStation == -1 &&
                                    <FormHelperText id="my-helper-text-power-station">Campo Obrigatório.</FormHelperText>

                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="gwid">GWID</InputLabel>
                                <TextField
                                    type="number"
                                    error={gwid === null}
                                    id="gwid"
                                    variant="standard"
                                    placeholder={"Digite o GWID"}
                                    onChange={(value) => setGwid(parseInt(value.target.value))}
                                    value={gwid}
                                />
                                <IconButton onClick={handleGwid} sx={{
                                    marginLeft: '10px',
                                    backgroundColor: '#818181',
                                    width: '50px',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        backgroundColor: '#6b6b6b', // Cor um pouco mais escura no hover
                                    }
                                }}>
                                    <Typography sx={{
                                        fontSize: '12px',
                                        color: '#fff',
                                        '&:hover': {
                                            color: '#000' // Fica preto no hover
                                        }
                                    }}>
                                        Gerar
                                    </Typography>
                                </IconButton>
                                {
                                    gwid === null &&
                                    <FormHelperText id="my-helper-text">Campo Obrigatório.</FormHelperText>
                                }
                            </Box>
                            <Box style={{marginBottom: 20}}>
                                <FormControlLabel
                                    control={
                                        <Switch value={enabled} checked={enabled} onChange={(e) => setEnabled(e.target.checked)}/>
                                    }
                                    label="Habilitar Broker"
                                />
                            </Box>
                        </div>
                    </Container>
                </ACard>
            </Box>
        </>
    )
}

export function BrokerHomePageForm() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <BrokerFormPage/>
        </QueryClientProvider>
    )
}